export enum GoogleOAuthType {
    ServiceAccount = "Service Account",
    SignInButton = "Sign In Button"
}